import { scaleLinear } from "@visx/scale";
import * as mathjs from "mathjs";

import { Marker } from "@/types/defs/pitchCorrection/marker";

export const calculatePitchesForVibratoChange = (
  knobValue: number,
  knobVibratoValueReference: number,
  circles: Marker[],
  knobVibratoPitchListReference: number[]
) => {
  const referenceSegments_: number[][] = [[]];

  let pitchIx = 0;
  let circleIx = 0;
  while (true) {
    let changedCircleIx = false;
    while (
      circles[circleIx].index <= pitchIx &&
      circleIx < circles.length - 1
    ) {
      circleIx++;
      changedCircleIx = true;
    }
    if (circleIx >= circles.length) {
      break;
    }
    if (
      referenceSegments_[referenceSegments_.length - 1].length !== 0 &&
      changedCircleIx
    ) {
      referenceSegments_.push([]);
    }
    referenceSegments_[referenceSegments_.length - 1].push(
      knobVibratoPitchListReference[pitchIx]
    );
    pitchIx++;
    if (pitchIx >= knobVibratoPitchListReference.length) {
      break;
    }
  }
  const referenceSegments = referenceSegments_.filter((s) => s.length > 0);

  const amm = referenceSegments.map((z) =>
    z[0] === 0 ? 0 : mathjs.median([...z].sort().filter((i) => i !== 0))
  );
  const scales = referenceSegments.map((s, i) =>
    s.map((v) =>
      scaleLinear({
        domain: [knobVibratoValueReference, 100],
        range: [v, amm[i]],
      })
    )
  );
  return referenceSegments
    .map((s, i) => s.map((x, j) => (x === 0 ? 0 : scales[i][j](knobValue))))
    .flat();
};
